import PropTypes from 'prop-types';
var propTypes = {
  appearance: PropTypes.oneOf(['primary', 'secondary', 'ghost']),
  children: PropTypes.node,
  className: PropTypes.string,
  colorScheme: PropTypes.oneOf(['default', 'positive', 'negative', 'warning', 'caution']),
  customStyle: PropTypes.any,
  disabled: PropTypes.bool,
  expanded: PropTypes.bool,
  forceActive: PropTypes.bool,
  id: PropTypes.string,
  leadingIcon: PropTypes.element,
  loading: PropTypes.bool,
  name: PropTypes.string,
  small: PropTypes.bool,
  trailingIcon: PropTypes.element,
  type: PropTypes.oneOf(['submit', 'reset', 'button'])
};
export default propTypes;